<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="68px">
      <el-row>
            <el-form-item label="歌曲名称">
              <el-input v-model="queryParams.qumu_name" placeholder="请输入歌曲名称" clearable  size="small" />
            </el-form-item>
     
            <el-form-item label="歌曲曲风">
              <el-select style="width: 100%;" v-model="queryParams.qumu_qufeng" placeholder="请选择">
                <el-option v-for="item in options" :key="item.prod_type" :label="item.label" :value="item.prod_type">
                </el-option>

              </el-select>
            </el-form-item>
  
            <el-form-item label="365歌曲">
              <el-select style="width: 100%;" v-model="queryParams.qumu_365_show" placeholder="请选择">
                <el-option v-for="item in show365" :key="item.prod_type" :label="item.label" :value="item.prod_type">
                </el-option>

              </el-select>
            </el-form-item>


            <el-form-item label="歌曲状态">
              <el-select style="width: 100%;" v-model="queryParams.qumu_state" placeholder="请选择">
                <el-option v-for="item in stateOptions" :key="item.prod_type" :label="item.label"
                  :value="item.prod_type">
                </el-option>

              </el-select>
            </el-form-item>

            <el-form-item label="伴奏说明">
              <el-select style="width: 100%;" v-model="queryParams.qumu_shuoming" placeholder="请选择">
                <el-option v-for="item in intro" :key="item.prod_type" :label="item.label" :value="item.prod_type">
                </el-option>

              </el-select></el-form-item>
            <!-- <el-form-item label="伴奏指法">
              <el-input v-model="queryParams.qumu_zhifa" placeholder="多个链接用英文逗号“,”分隔" clearable size="small" />
            </el-form-item> -->
      

        </el-row>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini"
          @click="handleQuery2">查询</el-button>
        <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
      </el-form-item>
    </el-form>

    <div class="gap"></div>
    <div style="text-align: left; padding-left: 20px;">
      <el-button type="primary" icon="el-icon-add" :loading="loading" size="mini" @click="handleAdd">新增</el-button>



    </div>
    <el-table v-loading="loading" :data="list">
      <el-table-column label="歌曲字母" align="center" label-class-name='title' prop="qumu_zimu" />
      <el-table-column label="歌曲名称" align="center" label-class-name='title' prop="qumu_name" />
      <el-table-column label="歌曲曲风" align="center"  :formatter="transType" label-class-name='title' prop="qumu_qufeng" />
      <el-table-column label="歌曲图片" align="center"   label-class-name='title' prop="qumu_pic" >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: center;" >
            <img v-for="(item,index) in (scope.row.qumu_pic.split(','))"  class="img" :src="baseUrl+ item" alt="">
          </div>

        </template>
        </el-table-column>
      <el-table-column label="365歌曲" align="center" :formatter="trans365" label-class-name='title' prop="qumu_365_show" />
      <el-table-column label="歌曲状态" align="center" :formatter="transState"  label-class-name='title' prop="qumu_state" />
      <!-- <el-table-column label="伴奏" align="center" label-class-name='title' width="400" prop="qumu_banzou" /> -->
      <el-table-column label="歌曲说明" align="center" label-class-name='title' prop="qumu_shuoming" />
      <el-table-column label="歌曲指法" align="center" label-class-name='title' prop="qumu_zhifa" />
      <el-table-column label="备注" align="center" label-class-name='title' prop="qumu_mark" />
      <el-table-column label="曲目介绍" align="center" label-class-name='title' prop="qumu_intro" />
      <el-table-column label="创建时间" align="center" label-class-name='title' prop="qumu_create_time" />
      <el-table-column label="操作" align="center" width="200" label-class-name='title'
        class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button class="inspect-button" size="mini" type="primary" icon="el-icon-edit"
          @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button" size="mini" type="danger" icon="el-icon-delete"
            @click="handleDelete(scope.row)">删除</el-button>
          <!-- <el-button v-if="scope.row.judge == '0' && scope.row.state == '1'" class="inspect-button"
                     size="mini"
                     type="primary"
                     @click="handleJudge(scope.row)">评价</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-view"
                     @click="handleView(scope.row)">查看</el-button>
 
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDelete(scope.row.id)">删除</el-button> -->
        </template>
      </el-table-column>


    </el-table>
    <el-pagination v-show="total > 0" :total="total" @current-change="getList" @prev-click='getList'
      @next-click="getList" />
    <!-- 操作日志详细 -->
    <el-dialog title="产品新增" :visible.sync="open" :close-on-click-modal="false" width="500px" append-to-body>
      <el-form ref="form" :model="form" label-width="100px" size="mini">
        <el-row>
          <el-col :span="24">
            <el-form-item label="歌曲名称">
              <el-input v-model="form.qumu_name" placeholder="请输入歌曲名称" clearable size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
          <el-form-item label="歌曲首字母">
              <el-input v-model="form.qumu_zimu" placeholder="请输入歌曲拼音首字母" clearable maxlength="1"  size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.qumu_mark" placeholder="请输入备注" clearable size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="歌曲曲风">
              <el-select style="width: 100%;" v-model="form.qumu_qufeng" placeholder="请选择">
                <el-option v-for="item in options" :key="item.prod_type" :label="item.label" :value="item.prod_type">
                </el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" >
            <el-form-item label="歌曲图片链接">
              <el-upload  :on-success="handleAvatarSuccess" :limit="limit" :action="action" :file-list="fileList"
                list-type="picture-card" :on-remove="handleRemove">
                <!-- <i class="el-icon-plus"></i> -->
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="365歌曲">
              <el-select style="width: 100%;" v-model="form.qumu_365_show" placeholder="请选择">
                <el-option v-for="item in show365" :key="item.prod_type" :label="item.label" :value="item.prod_type">
                </el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24">
            <el-form-item label="添加时间">
              <el-date-picker :span="24" v-model="form.date" format="yyyy-MM-dd" type="date" value-format="yyyy-MM-dd"
                style="width: 100%;" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col> -->

          <el-col :span="24">
            <el-form-item label="歌曲状态">
              <el-select style="width: 100%;" v-model="form.qumu_state" placeholder="请选择">
                <el-option v-for="item in stateOptions" :key="item.prod_type" :label="item.label"
                  :value="item.prod_type">
                </el-option>

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="伴奏链接">
              <el-input   type="textarea"
              :rows="6" v-model="form.qumu_banzou" placeholder="多个链接用逗号“,”分隔" clearable size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="伴奏说明">
              <el-input  type="textarea"
              :rows="3"  v-model="form.qumu_shuoming" placeholder="多个说明用逗号“,”分隔" clearable size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="伴奏指法">
              <el-input   type="textarea"
              :rows="3"  v-model="form.qumu_zhifa" placeholder="多个链接用逗号“,”分隔" clearable size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="介绍内容">
              <el-input   type="textarea"
              :rows="6"  v-model="form.qumu_intro" placeholder="介绍内容" clearable size="small" />
            </el-form-item>
          </el-col>
   

        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>



</template>

<script>
import config from '../../config/config'
import { recordList, qukuAdd, qukuList, qukuDelete, qukuUpdate } from '../api/quku/index';
import { Notification, MessageBox, Message, Link } from "element-ui";
export default {
  name: 'Operlog',
  data () {
    return {
      baseUrl:'',
      flag:false,
      fileList: [],
      limit: 2,
      baseURL: '',  //  图片上传地址
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      intro: [
        { prod_type: 'C', label: 'C调' },
        { prod_type: 'D', label: 'D调' },
        { prod_type: 'E', label: 'E调' },
        { prod_type: 'F', label: 'F调' },
        { prod_type: 'G', label: 'G调' },
        { prod_type: 'A', label: 'A调' },
        { prod_type: 'bB', label: 'bB调' },
        { prod_type: 'B', label: 'B调' },
        { prod_type: 'bD', label: 'bD调' },
        { prod_type: 'bE', label: 'bE调' },
        { prod_type: 'bG', label: 'bG调' },
        { prod_type: 'bA', label: 'bA调' },
      ],
      show365: [
        { prod_type: '', label: '空' },
        { prod_type: '1', label: '是' },
        { prod_type: '0', label: '否' },
      ],
      stateOptions: [
      { prod_type: '', label: '空' },
        { prod_type: '1', label: '正常' },
        { prod_type: '0', label: '停用' },
      ],
      options: [
        { prod_type: '', label: '空' },
        { prod_type: '0', label: '专业考级' },
        { prod_type: '1', label: '经典老歌' },
        { prod_type: '2', label: '网络流行' },
        { prod_type: '3', label: '草原情怀' },
        { prod_type: '4', label: '古风雅韵' },
        { prod_type: '5', label: '红歌精选' },
        { prod_type: '6', label: '影视金曲' },
        { prod_type: '7', label: '西北风情' },
        { prod_type: '8', label: '国外歌曲' },
        { prod_type: '9', label: '其他类型' },
      ],

      list: [],
      form: {
        qumu_name: '',
        qumu_qufeng: '',
        qumu_pic: '',
        qumu_365_show: '1',
        qumu_state: '1',
        qumu_mark: '',
        qumu_banzou: '',
        qumu_shuoming: '',
        qumu_zhifa: '',
      },
      open: false,
      pageIndex: 1,
      pageSize: 10,
      // 禁用状态
      disabled: false,
      queryParams: {
        qumu_365_show:'',
        qumu_state:''
      },
      loading: false,
      // table 列表数据
      list: [],
      // 总条数
      total: 0,

    }
  },

  created () {
    this.baseUrl = config.baseUrl;
    this.action = config.baseUrl + 'manageSystem/staticImageUpload';
    console.log(this.action)
    // let time  = new Date();
    // let date = time.getFullYear() + time.getMonth() + time.getDate();
    // let year = time.getFullYear();
    // let month = time.getMonth()+1;
    // month = month>= 10 ? month : '0'+month;
    // let day = time.getDate();
    // day = day >= 10 ? day : "0"+day;
    // this.queryParams ={date: year+'-'+month+'-'+day}
    this.handleQuery();
  },
  methods: {
    handleAvatarSuccess (res, file) {
      console.log(this.fileList)
      this.fileList.push(file)
      console.log(this.fileList)
    },
    handleRemove (file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList
      console.log(this.fileList)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload (file) {
      console.log(file);
    },
    handleUpdate (row) {
      this.flag = false,
      this.open = true;
      let fileList = row.qumu_pic.split(',');
      let temp = [];
      for(let i=0;i<fileList.length;i++){
        debugger
        let obj = {name: 'food.jpg', url:this.baseUrl +  fileList[i]}
        temp.push(obj)
      }
      debugger
      this.fileList = temp
      
      this.form = {
        id: row.id,
        qumu_name: row.qumu_name,
        qumu_qufeng: row.qumu_qufeng,
        // qumu_pic: row.qumu_pic,
        qumu_365_show: row.qumu_365_show,
        qumu_state:row.qumu_state,
        qumu_mark: row.qumu_mark,
        qumu_banzou: row.qumu_banzou,
        qumu_shuoming: row.qumu_shuoming,
        qumu_zhifa:row.qumu_zhifa,
        qumu_zimu:row.qumu_zimu,
        qumu_intro:row.qumu_intro,
      }
    },
    handleDelete (row) {
      let params = {
        id: row.id,
      }
      
      this.$confirm('确认删除吗？')
        .then(() => {
          qukuDelete(params).then(res => {
            this.$message.success('删除成功')
            this.handleQuery()
          })
        })
        .catch(_ => { });

    },
    submit () {
      console.log(this.form)
      debugger
      let fileList = this.fileList;
      let qumu_pic = []
      let baseUrl = this.baseUrl;
      for(let i=0;i<fileList.length;i++){
        console.log(fileList[i].url)
        if(fileList[i].url.indexOf(baseUrl) > -1){
          let url = fileList[i].url.replaceAll(baseUrl,'')
          qumu_pic.push(url)
        }else{
          qumu_pic.push(fileList[i].response.data.url)
        }

      }
      let params = this.form;
      params.qumu_pic = qumu_pic.toString()
      console.log(params)
      params.qumu_banzou = params.qumu_banzou.replaceAll('，',',')
      params.qumu_shuoming = params.qumu_shuoming.replaceAll('，',',')
      params.qumu_zhifa = params.qumu_zhifa.replaceAll('，',',')
      if(!params.qumu_name){
        return this.$message.error('曲目不能为空')
      }
     
      if(!params.id){
        if(!params.qumu_pic){
        return this.$message.error('请上传歌曲图片')
      }
      }
    
      if(!params.qumu_banzou){
        return this.$message.error('歌曲伴奏链接不能为空')
      }
      if(!params.qumu_shuoming){
        return this.$message.error('歌曲说明链接不能为空')
      }
      if(!params.qumu_zhifa){
        return this.$message.error('歌曲指法不能为空')
      }
      if(!params.qumu_mark){
        return this.$message.error('歌曲备注不能为空')
      }
      if (!params.id) {
        qukuAdd(this.form).then(res => {
          this.$message.success('新增成功')
          this.open = false
          this.handleQuery()
        })
      } else {
        qukuUpdate(this.form).then(res => {
          this.$message.success('修改成功')
          console.log(res)
          this.open = false
          this.handleQuery()
        })
      }
    },
    // 翻译评价类型
    transType (row) {
      let list = this.options;
      for(let i=0;i<list.length;i++){
        if(list[i].prod_type == row.qumu_qufeng){
          return list[i].label
        }
      }
    },
    // 365歌曲
    trans365 (row) {
      
      let list = this.show365
      for(let i=0;i<list.length;i++){
        if(list[i].prod_type == row.qumu_365_show){
          return list[i].label
        }
      }
    },
    // 状态翻译
    transState (row) {
      let list = this.stateOptions
      for(let i=0;i<list.length;i++){
        if(list[i].prod_type == row.qumu_state){
          return list[i].label
        }
      }
    },
     // 曲调
     transIntro (row) {
      let list = this.intro
      for(let i=0;i<list.length;i++){
        if(list[i].prod_type == row.qumu_shuoming){
          return list[i].label
        }
      }
    },

    //  退出
    logout () {
      localStorage.clear();
      this.$router.push('/')
    },
    // 新增按钮
    handleAdd () {
      this.open = true
      this.flag = true
      this.fileList = []
      this.form = {
        qumu_name: '',
        qumu_qufeng: '',
        qumu_pic: '',
        qumu_365_show: '0',
        qumu_state: '1',
        qumu_mark: '',
        qumu_banzou: '',
        qumu_shuoming: '',
        qumu_zhifa: '',
        qumu_zimu: '',
      }
    },
    handleQuery2(){
      this.pageIndex = 1;
      this.pageSize = 10;
      this.handleQuery()
    },
    // 查询按钮个
    handleQuery () {
      let params = this.queryParams;
      params.pageIndex = this.pageIndex;
      params.pageSize = this.pageSize;

      this.list = []
      qukuList(params).then(res => {
        
        this.list = res.data.list;
        console.log(this.list)
        this.total = res.data.total
        console.log(this.total)
      })
    },

    //  上一页面
    preClick (e) {

      this.pageIndex = e;
      if (pageIndex <= 1) { return }
      this.handleQuery()
    },
    // 下一页
    preClick () {
      let pageIndex = this.pageIndex + 1;

      if (pageIndex * this.pageSize >= this.total) {
        return
      }
      this.pageIndex = pageIndex;
      this.handleQuery()
    },
    // 获取列表
    getList (e) {
      this.pageIndex = e
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      }
      qukuList(params).then(res => {

        this.list = res.data.list;
        this.total = res.data.total
        console.log(this.total)
      })
    }
  }
}
</script>
<style>
.app-container {
  margin-top: 40px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.img{
  width: 50px;
  height: 50px;
  margin-left: 10px;
}
.el-upload-list--picture-card .el-upload-list__item{
  width: 100px;
  height: 100px !important;
}
.el-upload--picture-card{
  width: 100px;
  height: 100px !important;
  line-height: 100;
}

</style>



// WEBPACK FOOTER //
// src/views/active.vue